// hide feature PBI23284 implemented in #369
// if permanently enabled, remove its use in code and tests
export const IS_FEATURE_MOVING_LOCATIONS_BETWEEN_LEADING_COMPANIES_ENABLED =
  false
